import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as axios from 'axios';
import InputMask from 'react-input-mask';
import { Link } from 'gatsby';

import close from './media/close.svg';
import mts from '../media/mts.svg';
import a1 from '../media/a1.svg';

import './style.css';

function unfade(element) {
    var op = 0.1;  // initial opacity
    element.style.display = 'block';
    var timer = setInterval(function () {
        if (op >= 1){
            clearInterval(timer);
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += op * 0.1;
    }, 10);
}

function fade(element) {
    var op = 1;  // initial opacity
    var timer = setInterval(function () {
        if (op <= 0.1){
            clearInterval(timer);
            element.style.display = 'none';
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
    }, 10);
    
}

class Callback extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            phone: '',
            active: false,
            mailSent: false,
            error: null
        }

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
		var callback = document.getElementById('callback');
        unfade(callback);
    }
    
    componentDidUpdate() {
        if (this.state.name !== '' && this.state.phone !== '' && this.state.phone !== '+375 (__) ___-__-__' && this.state.active === false) {
            this.setState({
                active: true
            })
        } else if ((this.state.name === '' || this.state.phone === '' || this.state.phone === '+375 (__) ___-__-__') && this.state.active === true) {
            this.setState({
                active: false
            })
        }
    }

	toggleModal() {
        var callback = document.getElementById('callback');
        fade(callback);
        setTimeout(function() {
            this.props.click();
        }.bind(this), 500)
	};
	
	handleFormSubmit (e) {
        let form = document.getElementById('form-order');
        e.preventDefault();
        axios({
            method: 'post',
            url: `${this.props.url+'php/callback-product.php'}`,
            headers: { 'content-type': 'application/json' },
            data: this.state
        })
        .then(result => {
            form.reset();
            this.setState({
                mailSent: result
            })
        })
        .catch(error => this.setState({ error: error.message }));
    };

    render() {
        return(
            <div className="callback-modal">
                <div className="callback-modal-window" id="callback">
                    <div className="callback-modal-background" onClick={this.toggleModal.bind(this)}
                                onKeyDown={this.toggleModal} role="button"
                                tabIndex="0"></div>
                    <div className="callback-modal-body">
                        <div className="callback-dismiss" onClick={this.toggleModal.bind(this)}
                            onKeyDown={this.toggleModal} role="button"
                            tabIndex="0">
                            <img src={close} alt="close-btn" />
                        </div>
                        <h4 className="callback-modal-header">Заказ обратного звонка</h4>
                        <form className="callback-modal-form" action="">
                            <input className="callback__input-field"
                                type="text"
                                name="name"
                                placeholder="Имя"
                                onChange={e => this.setState({ name: e.target.value })} />
							<InputMask
                                mask="+375\ (99) 999-99-99" maskChar="_"
                                className="callback__input-field"
                                type="tel"
                                name="tel"
                                placeholder="Номер телефона"
                                onChange={e => this.setState({ phone: e.target.value })} 
                            />
                            <button className={this.state.active === true ? "callback__btn-submit" : "callback__btn-submit callback__btn-submit_disabled"}
                                type="submit"
                                disabled={this.state.active === true ? false : true}
                                onClick={e => this.handleFormSubmit(e)}>Перезвоните мне, пожалуйста!</button>
                        </form>
                        <h5 className="callback-modal-small-header">Или позвоните нам</h5>
                        <a href={'tel:'+this.props.mts.call} className="modal-phone"><img src={mts} className="modal__contact-icon" alt="icon" />{this.props.mts.phone}</a>
                        <a href={'tel:'+this.props.a1.call} className="modal-phone"><img src={a1} className="modal__contact-icon" alt="icon" />{this.props.a1.phone}</a>
                        <Link to="/contacts" className="modal-work-hours">{this.props.work_info}</Link>
                    </div>
                </div>
            </div> 
        )
    }
}

const mapStateToProps = (state) => {
    return {
        phoneIsOpen: state.phoneIsOpen,
        url: state.site_options.SITE_URL
    };
};

export default connect(mapStateToProps)(Callback);